import { useMediaApplicationContext } from '../../../../../../components/MediaApplicationContext';
import useInternetInfo from '../../../../../../hooks/useInternetInfo';
import { ProductMedia } from '../../../../ProductTypes';
import ProductMediaRenderer from '../../ProductMediaRenderer';

interface GalleryMediaProps {
  media: ProductMedia;
  onMobileContainerCover?: boolean;
}

const GalleryMedia = ({ media, onMobileContainerCover }: GalleryMediaProps) => {
  const mediaContext = useMediaApplicationContext();
  const { internetSpeed } = useInternetInfo();

  return (
    <ProductMediaRenderer
      mediaUrl={
        media.type === 'IMAGE' ? mediaContext.getMediaFromSize(media.url, 'md', 'webp') : media.url
      }
      previewUrl={mediaContext.getMediaFromSize(
        media.url,
        internetSpeed === 'fast' ? 'sm' : 'xs',
        'webp',
      )}
      type={media.type}
      onMobileContainerCover={onMobileContainerCover}
    />
  );
};

export default GalleryMedia;
